import { config } from "../../config"

interface IGeoErrorMessages {
  [key:string] : string
}

type GeoErrorProps = {
  message: string | null,
  isError: boolean
}

const messageMap:IGeoErrorMessages = {
  OK: 'everything worked fine', // unused in this scope
  ZERO_RESULTS: 'No results were found for your search term.',
  OVER_DAILY_LIMIT: 'There have been too many calls to this API. The API will be available again tomorrow.',
  OVER_QUERY_LIMIT: 'There have been too many calls to this API. The API will be available again tomorrow.',
  REQUEST_DENIED: 'The request to this API was denied by the server',
  INVALID_REQUEST: 'There was not enough information in your search to successfully complete the request. Please add more information and try again.',
  UNKNOWN_ERROR: 'An error has occured.'
}

const GeoError = ({
  message = 'OK',
  isError
}:GeoErrorProps) => {
  return (
    <>
      {isError && message &&  <div aria-live='polite' className={`${config.namespace}-geo-error nsw-form__helper nsw-form__helper--error`} ><span className="material-icons nsw-material-icons" aria-hidden="true">cancel</span>Something went wrong with your request. {messageMap[message]} </div>}
    </>
  )
}

export default GeoError
